export const environment = {
  production: false,
  systemId: 331,
  api: {
    url: 'https://api-cidadaodigital.test.betha.cloud/api',
  },
  authentication: {
    scope:
      'admin.cidadao-digital,contas-usuarios.suite,glb.suite,notifications.suite,sistema_interno,user-accounts.suite,licenses.suite',
    clientId: '0b7f8ca1-7496-41bb-82a4-cfa08c6df009',
  },
  externalResources: {
    envJsUrl: 'https://variaveis.test.plataforma.betha.cloud/env.js',
  },
};
